export default "__VITE_ASSET__DRHCz$r3__"